import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.match";
import _slice from "lodash/slice";
import _findIndex from "lodash/findIndex";
import _findLastIndex from "lodash/findLastIndex";
import _map from "lodash/map";
import PropTypes from 'prop-types';

var regexPattern = function regexPattern(matcher) {
  return {
    optional: false,
    matcher: matcher
  };
};

var optionalCharacter = function optionalCharacter(c) {
  return {
    optional: true,
    matcher: "\\".concat(c),
    value: c
  };
};

var optionalDash = {
  optional: true,
  matcher: /-/,
  value: ''
};
var Pattern = {
  digit: regexPattern(/[0-9]/),
  optionalCharacter: optionalCharacter,
  optionalDash: optionalDash
};
export var propType = PropTypes.array;
/**
 * Transforms an input string according to a schema. Returns an array of strings
 * corresponding to each character's transform.
 * @param {Array[Pattern]} schema
 * @param {String} rawValue
 * @param {boolean} inserting whether or not the rawValue is shrinking or growing, impacts proactive inserts/deletes
 * @return {Array[String]}
 */

export function transformInput(schema, rawValue) {
  var inserting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var patternIndex = 0;

  var transformed = _map(rawValue, function (character) {
    var i = patternIndex;
    var optionalBuffer = '';

    while (i < schema.length) {
      var _schema$i = schema[i],
          matcher = _schema$i.matcher,
          optional = _schema$i.optional,
          value = _schema$i.value;

      if (character.match(matcher)) {
        patternIndex = i + 1;
        return "".concat(optionalBuffer).concat(character);
      } else if (optional) {
        optionalBuffer += value || '';
        i += 1;
      } else {
        return '';
      }
    }

    return optionalBuffer;
  }); // Gross hack is gross because of old flow on Jenkins. _.map returns `string[]`, but old flow thinks `string`


  if (!inserting) {
    // If we're deleting, we want to trim optionals
    var lastRequired = _findLastIndex(schema, function (o) {
      return !o.optional;
    }, patternIndex - 1); // If we're deleting past a single optional character and that character
    // contains only whitespace, remove the required character preceding the
    // whitespace.
    // `4444 4444 ` -> `4444 444`
    // `1 / 23 / ` -> `1 / 23`


    if (lastRequired === patternIndex - 1 && schema[patternIndex] && schema[patternIndex].value && schema[patternIndex].value.match(/\s/)) {
      return transformed.slice(0, lastRequired);
    } else if (lastRequired >= 0) {
      return transformed.slice(0, lastRequired + 1);
    } else {
      return transformed;
    }
  } else if (transformed.length) {
    // Otherwise, proactively insert optionals
    var nextRequired = _findIndex(schema, function (o) {
      return !o.optional;
    }, patternIndex);

    var trailingOptionals = _map(_slice(schema, patternIndex, nextRequired), 'value');

    return transformed.slice(0, -1).concat(["".concat(transformed[transformed.length - 1]).concat(trailingOptionals.join(''))]);
  } else {
    return transformed;
  }
}
export default {
  propType: propType,
  transformInput: transformInput,
  Pattern: Pattern
};